import 'bootstrap/dist/js/bootstrap.bundle';
import '@popperjs/core';
import 'bootstrap-select';
import 'bootstrap-slider';
import 'bootstrap-slider/dist/css/bootstrap-slider.css';
import { CountUp } from 'countup.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.css';
import { Loader } from '@googlemaps/js-api-loader';
import '@googlemaps/markerclusterer';
import 'jquery-hoverintent';
import 'jquery-inview';
import 'jquery-match-height';
import 'jquery-parallax.js';
import 'jquery-smooth-scroll';
import 'object-fit-images';
import 'superfish';
import 'swiper';
import 'waypoints/lib/noframework.waypoints.min';

$(document).ready(function () {
    $('.equal-height').matchHeight();
});

function initializeMatrixBackgroundReveal() {
    const matrices = document.querySelectorAll('.content-matrix');
    if (!matrices.length) {
        return;
    }

    if (!('IntersectionObserver' in window)) {
        matrices.forEach((matrix) => matrix.classList.add('is-background-visible'));
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            entry.target.classList.toggle('is-background-visible', entry.isIntersecting);
        });
    }, {
        threshold: 0.5
    });

    matrices.forEach((matrix) => observer.observe(matrix));
}

$(document).ready(initializeMatrixBackgroundReveal);


//yield-calculator start
$(document).ready(function () {
    if( $(".container-yield-calculator").length > 0 ) {
        (function (funcName, baseObj) {
            funcName = funcName || "docReady";
            baseObj = baseObj || window;
            var readyList = [];
            var readyFired = false;
            var readyEventHandlersInstalled = false;

            function ready() {
                if (!readyFired) {
                    readyFired = true;
                    for (var i = 0; i < readyList.length; i++) {
                        readyList[i].fn.call(window, readyList[i].ctx);
                    }
                    readyList = [];
                }
            }

            function readyStateChange() {
                if (document.readyState === "complete") {
                    ready();
                }
            }

            baseObj[funcName] = function (callback, context) {
                if (typeof callback !== "function") {
                    throw new TypeError("callback for docReady(fn) must be a function");
                }
                if (readyFired) {
                    setTimeout(function () {
                        callback(context);
                    }, 1);
                    return;
                } else {
                    readyList.push({fn: callback, ctx: context});
                }
                if (document.readyState === "complete") {
                    setTimeout(ready, 1);
                } else if (!readyEventHandlersInstalled) {
                    if (document.addEventListener) {
                        document.addEventListener("DOMContentLoaded", ready, false);
                        window.addEventListener("load", ready, false);
                    } else {
                        document.attachEvent("onreadystatechange", readyStateChange);
                        window.attachEvent("onload", ready);
                    }
                    readyEventHandlersInstalled = true;
                }
            }
        })("docReady", window);

        docReady(function (context) {
            $('[data-toggle="tooltip"]').tooltip();

            $(function () {
                $('[data-toggle="tooltip"]').tooltip()
            }),

                $(function () {
                    $('[data-toggle="popover"]').popover({container: 'body'})
                }),

                $("#tax").slider({tooltip: 'hide', precision: 4});
            $("#commission").slider({tooltip: 'hide', precision: 4});
            $("#notary").slider({tooltip: 'hide', precision: 4});
            $("#rentPerNight").slider({tooltip: 'hide', precision: 4});
            $("#maintenanceCostsPerSquareMeter").slider({tooltip: 'hide', precision: 4});
            $("#utilization").slider({tooltip: 'hide', precision: 4});

            calculateCostsAndYield();

            $("#purchasePrice, #squareMeters").on("keyup", function (changeEvt) {
                calculateCostsAndYield();
            });


            $("#notary, #tax, #commission, #rentPerNight, #maintenanceCostsPerSquareMeter, #utilization").on("slide slideStop", function (slideEvt) {

                var target = slideEvt.target.id;
                var sliderValue = slideEvt.value;
                sliderValue = sliderValue.toLocaleString();

                if (target == 'rentPerNight' || target == 'maintenanceCostsPerSquareMeter') {
                    var unit = ',-€';
                } else {
                    var unit = '%';
                }
                $("#" + target + "SliderVal").text(sliderValue + unit);
                calculateCostsAndYield();

            });

        });

        function calculateCostsAndYield() {
            var squareMeters = parseInt($("#squareMeters").val());
            var utilization = parseFloat($("#utilization").val()) / 100;
            var maintenancePerMeters = parseInt($("#maintenanceCostsPerSquareMeter").val());
            var maintenanceCosts = squareMeters * maintenancePerMeters;

            var rentPerNight = $("#rentPerNight").val();
            var rentPerYear = 365 * utilization * rentPerNight;

            var netIncomeTotal = rentPerYear - maintenanceCosts;
            var netIncomeTotalString = netIncomeTotal.toLocaleString();

            var purchasePrice = parseInt($("#purchasePrice").val());
            var costsTotal = purchasePrice + purchasePrice * parseFloat($("#tax").val()) / 100 + purchasePrice * parseFloat($("#commission").val()) / 100 + purchasePrice * parseFloat($("#notary").val()) / 100;
            var costsTotalString = costsTotal.toLocaleString();

            if (purchasePrice > 10000 && squareMeters > 10) {
                $('#costsTotal').text(costsTotalString + ',-€');
                $('#incomeTotal').text(netIncomeTotalString + '€');

                var yield2 = Math.round((netIncomeTotal / costsTotal) * 10000) / 100;

                $('#maintenancePerYear').text('(' + maintenanceCosts.toLocaleString() + ',-€ / Jahr)');
                $('#yield').text(yield2.toLocaleString({'minimumFractionDigits': 2, 'style': 'decimal'}) + '%');
            } else {
                $('#maintenancePerYear').text('');
                $('#yield').text('Bitte Kaufpreis und Größe angeben!');
                return true;
            }
        }
    }
});
//yield-calculator end

// credit-calculator start
(function () {
    var federalStates = {
        'baden-wuerttemberg': {label: 'Baden-Württemberg', tax: 5},
        bayern: {label: 'Bayern', tax: 3.5},
        berlin: {label: 'Berlin', tax: 6},
        brandenburg: {label: 'Brandenburg', tax: 6.5},
        bremen: {label: 'Bremen', tax: 5},
        hamburg: {label: 'Hamburg', tax: 5.5},
        hessen: {label: 'Hessen', tax: 6},
        'mecklenburg-vorpommern': {label: 'Mecklenburg-Vorpommern', tax: 6},
        niedersachsen: {label: 'Niedersachsen', tax: 5},
        'nordrhein-westfalen': {label: 'Nordrhein-Westfalen', tax: 6.5},
        'rheinland-pfalz': {label: 'Rheinland-Pfalz', tax: 5},
        saarland: {label: 'Saarland', tax: 6.5},
        sachsen: {label: 'Sachsen', tax: 5.5},
        'sachsen-anhalt': {label: 'Sachsen-Anhalt', tax: 5},
        'schleswig-holstein': {label: 'Schleswig-Holstein', tax: 6.5},
        thueringen: {label: 'Thüringen', tax: 5}
    };
    var euroFormatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0
    });
    var percentFormatter = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    var numberFormatter = new Intl.NumberFormat('de-DE', {
        maximumFractionDigits: 0
    });
    var integerFormatter = new Intl.NumberFormat('de-DE', {
        maximumFractionDigits: 0,
        useGrouping: true
    });
    var dateFormatter = new Intl.DateTimeFormat('de-DE', {
        month: 'long',
        year: 'numeric'
    });

    var config = {
        purchasePriceMin: 50000,
        purchasePriceMax: 5000000,
        minimumEquityFactor: 0.12
    };

    function readNumber(value, fallback) {
        if (typeof value === 'string') {
            value = value.trim().replace(/\s/g, '').replace(/[€%]/g, '');

            if (value.indexOf(',') !== -1 && value.indexOf('.') !== -1) {
                value = value.replace(/\./g, '').replace(',', '.');
            } else if (value.indexOf(',') !== -1) {
                value = value.replace(',', '.');
            } else if (/^-?\d{1,3}(\.\d{3})+$/.test(value)) {
                value = value.replace(/\./g, '');
            }
        }

        var number = parseFloat(value);
        return isNaN(number) ? fallback : number;
    }

    function getValue(calculator, name, fallback) {
        var input = calculator.querySelector('[data-field="' + name + '"]');

        if (!input) {
            return fallback;
        }

        if (input.dataset.format === 'euro') {
            return readIntegerValue(input.value, fallback);
        }

        return readNumber(input.value, fallback);
    }

    function readIntegerValue(value, fallback) {
        if (typeof value === 'string') {
            var digits = value.replace(/\D/g, '');
            return digits ? parseInt(digits, 10) : fallback;
        }

        var number = parseInt(value, 10);
        return isNaN(number) ? fallback : number;
    }

    function formatIntegerInput(input) {
        var rawValue = input.value;
        var isActiveInput = input === document.activeElement;
        var previousScrollX = window.pageXOffset;
        var previousScrollY = window.pageYOffset;
        var caretPosition = isActiveInput ? input.selectionStart || rawValue.length : rawValue.length;
        var digitsBeforeCaret = rawValue.slice(0, caretPosition).replace(/\D/g, '').length;
        var numericValue = readIntegerValue(rawValue, null);

        if (numericValue === null || numericValue < 0) {
            input.value = '';
            return;
        }

        input.value = integerFormatter.format(Math.round(numericValue));

        if (!isActiveInput) {
            return;
        }

        var nextCaretPosition = input.value.length;
        var seenDigits = 0;

        for (var index = 0; index < input.value.length; index++) {
            if (/\d/.test(input.value.charAt(index))) {
                seenDigits++;
            }

            if (seenDigits >= digitsBeforeCaret) {
                nextCaretPosition = index + 1;
                break;
            }
        }

        input.setSelectionRange(nextCaretPosition, nextCaretPosition);
        window.scrollTo(previousScrollX, previousScrollY);
    }

    function formatEuroInputs(calculator) {
        Array.prototype.forEach.call(calculator.querySelectorAll('[data-format="euro"]'), function (input) {
            formatIntegerInput(input);
        });
    }

    function getQueryValue(names) {
        var params = new URLSearchParams(window.location.search);

        for (var index = 0; index < names.length; index++) {
            if (params.has(names[index]) && params.get(names[index]) !== '') {
                return params.get(names[index]);
            }
        }

        return null;
    }

    function normalizeFederalState(value) {
        if (!value) {
            return null;
        }

        var normalized = value.toString().toLowerCase()
            .replace(/ä/g, 'ae')
            .replace(/ö/g, 'oe')
            .replace(/ü/g, 'ue')
            .replace(/ß/g, 'ss')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');
        var aliases = {
            bw: 'baden-wuerttemberg',
            by: 'bayern',
            be: 'berlin',
            bb: 'brandenburg',
            hb: 'bremen',
            hh: 'hamburg',
            he: 'hessen',
            mv: 'mecklenburg-vorpommern',
            ni: 'niedersachsen',
            nw: 'nordrhein-westfalen',
            nrw: 'nordrhein-westfalen',
            rp: 'rheinland-pfalz',
            sl: 'saarland',
            sn: 'sachsen',
            st: 'sachsen-anhalt',
            sh: 'schleswig-holstein',
            th: 'thueringen',
            'baden-wurttemberg': 'baden-wuerttemberg',
            'mecklenburg-vorpommern': 'mecklenburg-vorpommern',
            'nordrhein-westfalen': 'nordrhein-westfalen',
            'rheinland-pfalz': 'rheinland-pfalz',
            'sachsen-anhalt': 'sachsen-anhalt',
            'schleswig-holstein': 'schleswig-holstein'
        };

        return aliases[normalized] || normalized;
    }

    function applyQueryDefaults(calculator) {
        var purchasePrice = getQueryValue(['kaufpreis', 'purchasePrice']);
        var brokerageFee = getQueryValue(['maklerkosten', 'brokerageFee']);
        var federalState = normalizeFederalState(getQueryValue(['bundesland', 'federalState']));
        var queryPurchasePrice = null;

        if (purchasePrice !== null) {
            queryPurchasePrice = readNumber(purchasePrice, readNumber(calculator.dataset.purchasePrice, 350000));
            setInputValue(calculator, 'purchasePrice', queryPurchasePrice);
            setInputValue(calculator, 'equity', Math.round(queryPurchasePrice * 0.5));
        }
        if (brokerageFee !== null) {
            setInputValue(calculator, 'brokerageFee', readNumber(brokerageFee, 0));
        }
        if (federalState && federalStates[federalState]) {
            setInputValue(calculator, 'federalState', federalState);
        }
    }

    function formatDecimalInput(input) {
        var number = readNumber(input.value, null);

        if (number === null) {
            input.value = '';
            return;
        }

        input.value = percentFormatter.format(number).replace(/,?0+$/, '');
    }

    function formatDecimalInputs(calculator) {
        Array.prototype.forEach.call(calculator.querySelectorAll('[data-format="decimal"]'), function (input) {
            formatDecimalInput(input);
        });
    }

    function getStringValue(calculator, name, fallback) {
        var input = calculator.querySelector('[data-field="' + name + '"]');
        return input && input.value ? input.value : fallback;
    }

    function setInputValue(calculator, name, value) {
        var input = calculator.querySelector('[data-field="' + name + '"]');

        if (input) {
            input.value = value;
        }
    }

    function setButtonState(calculator, fixedRateYears) {
        Array.prototype.forEach.call(calculator.querySelectorAll('[data-role="fixed-rate-buttons"] button'), function (button) {
            button.classList.toggle('is-active', parseInt(button.dataset.years, 10) === parseInt(fixedRateYears, 10));
        });
    }

    function setRangeLabels(calculator, monthlyRate, repaymentRate) {
        var monthlyRateLabel = calculator.querySelector('[data-role="monthly-rate-label"]');
        var repaymentRateLabel = calculator.querySelector('[data-role="repayment-rate-label"]');

        if (monthlyRateLabel) {
            monthlyRateLabel.textContent = euroFormatter.format(monthlyRate);
        }
        if (repaymentRateLabel) {
            repaymentRateLabel.textContent = percentFormatter.format(repaymentRate) + '%';
        }
    }

    function calculateAmortization(loanAmount, monthlyRate, interestRate, maxYears) {
        var monthlyInterest = interestRate / 100 / 12;
        var months = Math.max(1, Math.round(maxYears * 12));
        var remainingDebt = loanAmount;
        var interestTotal = 0;
        var totalPaid = 0;
        var points = [{year: 0, months: 0, debt: loanAmount, principalPaid: 0, interestPaid: 0}];
        var payoffMonth = null;

        for (var month = 0; month < months; month++) {
            var interest = remainingDebt * monthlyInterest;
            var principal = monthlyRate - interest;

            if (principal <= 0) {
                points.push({year: maxYears, debt: remainingDebt});
                break;
            }

            interestTotal += interest;
            totalPaid += Math.min(monthlyRate, remainingDebt + interest);
            remainingDebt -= principal;

            if (remainingDebt <= 0) {
                remainingDebt = 0;
                payoffMonth = month + 1;
                points.push({
                    year: (month + 1) / 12,
                    months: month + 1,
                    debt: 0,
                    principalPaid: loanAmount,
                    interestPaid: interestTotal
                });
                break;
            }

            points.push({
                year: (month + 1) / 12,
                months: month + 1,
                debt: remainingDebt,
                principalPaid: loanAmount - remainingDebt,
                interestPaid: interestTotal
            });
        }

        return {
            remainingDebt: remainingDebt,
            interestTotal: interestTotal,
            totalPaid: totalPaid,
            points: points,
            payoffYears: payoffMonth ? payoffMonth / 12 : null
        };
    }

    function getDebtAfterYears(points, years) {
        var debt = points.length ? points[points.length - 1].debt : 0;

        points.forEach(function (point) {
            if (point.year <= years) {
                debt = point.debt;
            }
        });

        return debt;
    }

    function addMonths(date, months) {
        var result = new Date(date.getTime());
        result.setMonth(result.getMonth() + months);
        return result;
    }

    function attachChartTooltip(element, values, settings) {
        var svg = element.querySelector('.credit-calculator__curve');
        var tooltip = element.querySelector('.credit-calculator__tooltip');
        var hoverLine = element.querySelector('[data-role="hover-line"]');
        var hoverPoint = element.querySelector('[data-role="hover-point"]');

        if (!svg || !tooltip || !hoverLine || !hoverPoint || !settings.points.length) {
            return;
        }

        function hideTooltip() {
            tooltip.classList.remove('is-visible');
            hoverLine.setAttribute('visibility', 'hidden');
            hoverPoint.setAttribute('visibility', 'hidden');
        }

        function getNearestPoint(year) {
            return settings.points.reduce(function (nearest, point) {
                return Math.abs(point.year - year) < Math.abs(nearest.year - year) ? point : nearest;
            }, settings.points[0]);
        }

        svg.addEventListener('mousemove', function (event) {
            var rect = svg.getBoundingClientRect();
            var svgX = (event.clientX - rect.left) / rect.width * settings.width;
            var year = Math.max(0, Math.min(settings.maxYear, (svgX - settings.padding.left) / settings.chartWidth * settings.maxYear));
            var point = getNearestPoint(year);
            var pointX = settings.padding.left + point.year / settings.maxYear * settings.chartWidth;
            var pointY = settings.padding.top + (1 - point.debt / settings.maxDebt) * settings.chartHeight;
            var tooltipX = event.clientX - rect.left + 16;
            var tooltipY = event.clientY - rect.top + 16;

            if (tooltipX + 260 > rect.width) {
                tooltipX = event.clientX - rect.left - 276;
            }
            if (tooltipY + 150 > rect.height) {
                tooltipY = event.clientY - rect.top - 154;
            }

            hoverLine.setAttribute('x1', pointX.toFixed(2));
            hoverLine.setAttribute('x2', pointX.toFixed(2));
            hoverLine.setAttribute('visibility', 'visible');
            hoverPoint.setAttribute('cx', pointX.toFixed(2));
            hoverPoint.setAttribute('cy', pointY.toFixed(2));
            hoverPoint.setAttribute('visibility', 'visible');
            tooltip.style.left = tooltipX + 'px';
            tooltip.style.top = tooltipY + 'px';
            tooltip.innerHTML = [
                '<div class="credit-calculator__tooltip-date">' + dateFormatter.format(addMonths(values.startDate, point.months)) + '</div>',
                '<dl>',
                '<div><dt>Restschuld</dt><dd>' + euroFormatter.format(point.debt) + '</dd></div>',
                '<div><dt>Getilgter Betrag</dt><dd>' + euroFormatter.format(point.principalPaid) + '</dd></div>',
                '<div><dt>Geleistete Zinzzahlungen</dt><dd>' + euroFormatter.format(point.interestPaid) + '</dd></div>',
                '</dl>'
            ].join('');
            tooltip.classList.add('is-visible');
        });

        svg.addEventListener('mouseleave', hideTooltip);
        svg.addEventListener('blur', hideTooltip);
    }

    function renderSummary(element, values) {
        var loanDetails = [
            '<details class="credit-calculator__loan-details">',
            '<summary aria-label="Berechnung des Darlehensbetrags anzeigen">' + euroFormatter.format(values.loanAmount) + '</summary>',
            '<dl>',
            '<div><dt>Kaufpreis</dt><dd>' + euroFormatter.format(values.purchasePrice) + '</dd></div>',
            '<div><dt>Grunderwerbsteuer</dt><dd>' + euroFormatter.format(values.realEstateTransferTaxAmount) + '</dd></div>',
            '<div><dt>Maklerkosten</dt><dd>' + euroFormatter.format(values.brokerageFeeAmount) + '</dd></div>',
            '<div><dt>Notar- und Grundbuchkosten</dt><dd>' + euroFormatter.format(values.notaryCostsAmount) + '</dd></div>',
            '<div><dt>Eigenkapital</dt><dd>-' + euroFormatter.format(values.equity) + '</dd></div>',
            '<div class="credit-calculator__loan-total"><dt>Darlehenssumme</dt><dd>' + euroFormatter.format(values.loanAmount) + '</dd></div>',
            '</dl>',
            '</details>'
        ].join('');

        element.innerHTML = [
            '<table class="credit-calculator__table">',
            '<tbody>',
            '<tr><th>Kaufpreis</th><td>' + euroFormatter.format(values.purchasePrice) + '</td></tr>',
            '<tr><th>Grunderwerbsteuer ' + percentFormatter.format(values.realEstateTransferTax) + '%</th><td>' + euroFormatter.format(values.realEstateTransferTaxAmount) + '</td></tr>',
            '<tr><th>Maklerkosten ' + percentFormatter.format(values.brokerageFee) + '%</th><td>' + euroFormatter.format(values.brokerageFeeAmount) + '</td></tr>',
            '<tr><th>Notar- und Grundbuchkosten</th><td>' + euroFormatter.format(values.notaryCostsAmount) + '</td></tr>',
            '<tr><th>Eigenkapital</th><td>' + euroFormatter.format(values.equity) + '</td></tr>',
            '<tr><th>Darlehensbetrag</th><td>' + loanDetails + '</td></tr>',
            '<tr><th>Monatliche Rate</th><td>' + euroFormatter.format(values.monthlyRate) + '</td></tr>',
            '<tr><th>Restschuld nach ' + numberFormatter.format(values.fixedRateYears) + ' Jahren</th><td>' + euroFormatter.format(values.fixedRateDebt) + '</td></tr>',
            '</tbody>',
            '</table>'
        ].join('');
    }

    function renderRuntime(element, values) {
        element.innerHTML = [
            '<div class="credit-calculator__runtime-label">Gesamtlaufzeit (geschätzt)</div>',
            '<div class="credit-calculator__runtime-value">' + values.payoffLabel + '</div>'
        ].join('');
    }

    function renderChart(element, values) {
        if (values.equity > values.purchasePrice) {
            element.innerHTML = '<div class="credit-calculator__success">Glückwunsch - Ihr Eigenkapital überschreitet den Kaufpreis</div>';
            return;
        }

        var width = 920;
        var height = 320;
        var padding = {top: 20, right: 28, bottom: 42, left: 78};
        var chartWidth = width - padding.left - padding.right;
        var chartHeight = height - padding.top - padding.bottom;
        var maxYear = Math.max(values.fixedRateYears, Math.ceil(values.payoffYears || 30), 10);
        maxYear = Math.min(Math.max(maxYear, 10), 40);
        var maxDebt = Math.max(values.loanAmount, 1);
        var points = values.points.filter(function (point) {
            return point.year <= maxYear;
        });
        var path = points.map(function (point, index) {
            var x = padding.left + point.year / maxYear * chartWidth;
            var y = padding.top + (1 - point.debt / maxDebt) * chartHeight;
            return (index === 0 ? 'M' : 'L') + x.toFixed(2) + ' ' + y.toFixed(2);
        }).join(' ');
        var fixedX = padding.left + values.fixedRateYears / maxYear * chartWidth;
        var fixedDebtY = padding.top + (1 - values.fixedRateDebt / maxDebt) * chartHeight;
        var yLabels = [1, 0.75, 0.5, 0.25, 0].map(function (factor) {
            var y = padding.top + (1 - factor) * chartHeight;
            return '<text x="0" y="' + (y + 4).toFixed(2) + '" class="credit-calculator__axis-label">' + euroFormatter.format(maxDebt * factor).replace(',00', '') + '</text>';
        }).join('');

        element.innerHTML = [
            '<div class="credit-calculator__chart-title">Restschuld im Zeitverlauf</div>',
            '<svg class="credit-calculator__curve" viewBox="0 0 ' + width + ' ' + height + '" role="img" aria-label="Restschuld im Zeitverlauf">',
            '<line x1="' + padding.left + '" y1="' + (padding.top + chartHeight) + '" x2="' + (padding.left + chartWidth) + '" y2="' + (padding.top + chartHeight) + '" class="credit-calculator__axis" />',
            '<line x1="' + padding.left + '" y1="' + padding.top + '" x2="' + padding.left + '" y2="' + (padding.top + chartHeight) + '" class="credit-calculator__axis" />',
            yLabels,
            '<text x="' + padding.left + '" y="' + (height - 10) + '" class="credit-calculator__axis-label">0 Jahre</text>',
            '<text x="' + (padding.left + chartWidth - 55) + '" y="' + (height - 10) + '" class="credit-calculator__axis-label">' + maxYear + ' Jahre</text>',
            '<path d="' + path + '" class="credit-calculator__curve-line" />',
            '<line x1="' + fixedX.toFixed(2) + '" y1="' + padding.top + '" x2="' + fixedX.toFixed(2) + '" y2="' + (padding.top + chartHeight) + '" class="credit-calculator__fixed-line" />',
            '<circle cx="' + fixedX.toFixed(2) + '" cy="' + fixedDebtY.toFixed(2) + '" r="5" class="credit-calculator__fixed-point" />',
            '<text x="' + Math.min(fixedX + 8, width - 150).toFixed(2) + '" y="' + Math.max(fixedDebtY - 10, 14).toFixed(2) + '" class="credit-calculator__fixed-label">' + values.fixedRateYears + ' Jahre</text>',
            '<line x1="0" y1="' + padding.top + '" x2="0" y2="' + (padding.top + chartHeight) + '" class="credit-calculator__hover-line" data-role="hover-line" visibility="hidden" />',
            '<circle cx="0" cy="0" r="5" class="credit-calculator__hover-point" data-role="hover-point" visibility="hidden" />',
            '<rect x="' + padding.left + '" y="' + padding.top + '" width="' + chartWidth + '" height="' + chartHeight + '" class="credit-calculator__hover-area" />',
            '</svg>',
            '<div class="credit-calculator__tooltip" role="status"></div>',
            '<div class="credit-calculator__rate-note">Restschuld nach Zinsbindung: ' + euroFormatter.format(values.fixedRateDebt) + '</div>'
        ].join('');

        attachChartTooltip(element, values, {
            width: width,
            maxYear: maxYear,
            maxDebt: maxDebt,
            padding: padding,
            chartWidth: chartWidth,
            chartHeight: chartHeight,
            points: points
        });
    }

    function renderValidation(messageElement, messages) {
        messageElement.innerHTML = messages.join('<br />');
        messageElement.classList.toggle('is-visible', messages.length > 0);
    }

    function updateCreditCalculator(calculator) {
        var purchasePriceInput = calculator.querySelector('[data-field="purchasePrice"]');
        var equityInput = calculator.querySelector('[data-field="equity"]');
        var summaryElement = calculator.querySelector('[data-role="summary"]');
        var runtimeElement = calculator.querySelector('[data-role="runtime"]');
        var chartElement = calculator.querySelector('[data-role="chart"]');
        var messageElement = calculator.querySelector('[data-role="message"]');
        var purchasePrice = getValue(calculator, 'purchasePrice', config.purchasePriceMin);
        var equity = getValue(calculator, 'equity', 0);
        var messages = [];

        if (purchasePrice < config.purchasePriceMin || purchasePrice > config.purchasePriceMax) {
            messages.push('Der Kaufpreis muss zwischen 50.000 Euro und 5.000.000 Euro liegen.');
        }

        var minimumEquity = purchasePrice * config.minimumEquityFactor;
        if (equity < minimumEquity) {
            messages.push('Das Eigenkapital muss mindestens 12% des Kaufpreises betragen (' + euroFormatter.format(minimumEquity) + ').');
        }

        if (purchasePriceInput) {
            purchasePriceInput.setAttribute('aria-invalid', purchasePrice < config.purchasePriceMin || purchasePrice > config.purchasePriceMax ? 'true' : 'false');
        }
        if (equityInput) {
            equityInput.min = Math.ceil(minimumEquity);
            equityInput.setAttribute('aria-invalid', equity < minimumEquity ? 'true' : 'false');
        }

        var federalStateKey = getStringValue(calculator, 'federalState', calculator.dataset.federalState || 'nordrhein-westfalen');
        var federalState = federalStates[federalStateKey] || federalStates['nordrhein-westfalen'];
        var interestRate = Math.max(0, getValue(calculator, 'interestRate', 0));
        var fixedRateYears = Math.max(1, readNumber(calculator.dataset.fixedRateYears, 10));
        var realEstateTransferTax = federalState.tax;
        var notaryCosts = Math.max(0, readNumber(calculator.dataset.notaryCosts, 0));
        var brokerageFee = Math.max(0, getValue(calculator, 'brokerageFee', readNumber(calculator.dataset.brokerageFee, 0)));
        var realEstateTransferTaxAmount = purchasePrice * realEstateTransferTax / 100;
        var notaryCostsAmount = purchasePrice * notaryCosts / 100;
        var brokerageFeeAmount = purchasePrice * brokerageFee / 100;
        var additionalCosts = realEstateTransferTaxAmount + notaryCostsAmount + brokerageFeeAmount;
        var loanAmount = Math.max(0, purchasePrice + additionalCosts - equity);
        var repaymentInput = calculator.querySelector('[data-field="repaymentRate"]');
        var monthlyRateInput = calculator.querySelector('[data-field="monthlyRate"]');
        var repaymentRate = Math.max(1, getValue(calculator, 'repaymentRate', 2));
        var monthlyRate = Math.max(0, getValue(calculator, 'monthlyRate', loanAmount * (interestRate + repaymentRate) / 100 / 12));
        var minMonthlyRate = loanAmount * interestRate / 100 / 12 + 1;

        if (calculator.dataset.lastEdited === 'repaymentRate' && monthlyRateInput) {
            monthlyRate = loanAmount * (interestRate + repaymentRate) / 100 / 12;
            monthlyRateInput.value = Math.round(monthlyRate / 50) * 50;
        } else if (calculator.dataset.lastEdited === 'monthlyRate' && repaymentInput && loanAmount > 0) {
            repaymentRate = Math.max(1, (monthlyRate * 12 / loanAmount * 100) - interestRate);
            repaymentInput.value = Math.min(10, Math.round(repaymentRate * 10) / 10);
        }

        if (monthlyRate <= minMonthlyRate && loanAmount > 0) {
            messages.push('Die monatliche Rate muss höher als die monatlichen Zinsen sein.');
        }

        setButtonState(calculator, fixedRateYears);
        setRangeLabels(calculator, monthlyRate, repaymentRate);

        var amortization = calculateAmortization(loanAmount, monthlyRate, interestRate, 40);
        var fixedRateDebt = getDebtAfterYears(amortization.points, fixedRateYears);
        var payoffLabel = amortization.payoffYears ? percentFormatter.format(amortization.payoffYears).replace(',', ',') + ' Jahre' : 'mehr als 40 Jahre';
        var values = {
            purchasePrice: purchasePrice,
            equity: equity,
            additionalCosts: additionalCosts,
            federalState: federalState,
            realEstateTransferTax: realEstateTransferTax,
            realEstateTransferTaxAmount: realEstateTransferTaxAmount,
            notaryCostsAmount: notaryCostsAmount,
            brokerageFee: brokerageFee,
            brokerageFeeAmount: brokerageFeeAmount,
            loanAmount: loanAmount,
            monthlyRate: monthlyRate,
            remainingDebt: amortization.remainingDebt,
            fixedRateYears: fixedRateYears,
            fixedRateDebt: fixedRateDebt,
            points: amortization.points,
            startDate: new Date(),
            payoffYears: amortization.payoffYears,
            payoffLabel: payoffLabel
        };

        renderValidation(messageElement, messages);
        renderRuntime(runtimeElement, values);
        renderSummary(summaryElement, values);
        renderChart(chartElement, values);
    }

    function initCreditCalculator(calculator) {
        setInputValue(calculator, 'purchasePrice', readNumber(calculator.dataset.purchasePrice, 350000));
        setInputValue(calculator, 'equity', readNumber(calculator.dataset.equity, 70000));
        setInputValue(calculator, 'monthlyRate', readNumber(calculator.dataset.monthlyRate, 1500));
        setInputValue(calculator, 'interestRate', readNumber(calculator.dataset.interestRate, 3.8));
        setInputValue(calculator, 'repaymentRate', readNumber(calculator.dataset.repaymentRate, 2));
        setInputValue(calculator, 'federalState', calculator.dataset.federalState || 'nordrhein-westfalen');
        setInputValue(calculator, 'brokerageFee', readNumber(calculator.dataset.brokerageFee, 3.57));
        applyQueryDefaults(calculator);
        formatEuroInputs(calculator);
        formatDecimalInputs(calculator);

        Array.prototype.forEach.call(calculator.querySelectorAll('.credit-calculator__input'), function (input) {
            input.addEventListener('input', function () {
                if (input.dataset.format === 'euro') {
                    formatIntegerInput(input);
                }

                updateCreditCalculator(calculator);
            });
            input.addEventListener('change', function () {
                if (input.dataset.format === 'euro') {
                    formatIntegerInput(input);
                } else if (input.dataset.format === 'decimal') {
                    formatDecimalInput(input);
                }

                updateCreditCalculator(calculator);
            });
        });

        Array.prototype.forEach.call(calculator.querySelectorAll('.credit-calculator__range'), function (input) {
            input.addEventListener('input', function () {
                calculator.dataset.lastEdited = input.dataset.field;
                updateCreditCalculator(calculator);
            });
            input.addEventListener('change', function () {
                calculator.dataset.lastEdited = input.dataset.field;
                updateCreditCalculator(calculator);
            });
        });

        Array.prototype.forEach.call(calculator.querySelectorAll('[data-role="fixed-rate-buttons"] button'), function (button) {
            button.addEventListener('click', function () {
                calculator.dataset.fixedRateYears = button.dataset.years;
                updateCreditCalculator(calculator);
            });
        });

        updateCreditCalculator(calculator);
    }

    document.addEventListener('DOMContentLoaded', function () {
        Array.prototype.forEach.call(document.querySelectorAll('.container-credit-calculator'), initCreditCalculator);
    });
})();
// credit-calculator end

document.addEventListener("DOMContentLoaded", function() {

    let links = document.querySelectorAll('a');
    links.forEach(function(item){
        if (item.getAttribute('data-mailto-token') != null) {
            item.innerHTML = item.innerHTML.replace('@~@', '@');
        }
    });

});




(function ($, window) {

    /**
     * Enable thumbnail support for Swiper
     * @param swiper (pass swiper element)
     * @param settings (pass custom options)
     */
    window.swiperThumbs = function (swiper, settings) {

        /**
         * Loop over swiper instances
         */
        $(swiper).each(function () {

            var _this = this;

            /**
             * Default settings
             */
            var options = {
                element: 'swiper-thumbnails',
                activeClass: 'is-active'
            }

            /**
             * Merge user settings and default settings
             */
            $.extend(options, settings);

            /**
             * Helper vars
             */
            var element = $('.' + options.element);

            /**
             * Get real activeIndex
             * @returns {*}
             */
            var realIndex = function (index) {
                // if index doesn't exist set index to activeIndex of swiper
                if (index === undefined) index = _this.activeIndex;

                // Check if swiper instance has loop before getting real index
                if (_this.params.loop) {
                    return parseInt(_this.slides.eq(index).attr('data-swiper-slide-index'));
                } else {
                    return index;
                }
            }

            var app = {

                init: function () {
                    app.bindUIevents();
                    app.updateActiveClasses(realIndex(_this.activeIndex));
                },

                bindUIevents: function () {
                    /**
                     * Bind click events to thumbs
                     */
                    element.children().each(function () {
                        $(this).on('click', function () {

                            // Get clicked index
                            var index = parseInt($(this).index());

                            // Get difference between item clicked and current real active index.
                            var difference = (index - realIndex());

                            // Move to slide that makes sense for the user by
                            // checking what the current active slide is and adding the difference
                            // this makes sure the swiper moves to a natural direction the user expects.
                            app.moveToSlide(_this.activeIndex + difference);
                        })
                    })

                    /**
                     * Update thumbs on slideChange
                     */
                    _this.on('slideChangeStart', function (swiper) {
                        app.updateActiveClasses(realIndex())
                    });
                },

                moveToSlide: function (index) {
                    _this.slideTo(index);
                },

                updateActiveClasses: function (index) {
                    element.children().removeClass(options.activeClass);
                    element.children().eq(index).addClass(options.activeClass);
                }
            }

            app.init();

        });

    };

}(jQuery, window));

var browserName = navigator.appName;
var browserVer = parseInt(navigator.appVersion);
var version = "";
var msie4 = (browserName == "Microsoft Internet Explorer" && browserVer >= 4);
if ((browserName == "Netscape" && browserVer >= 3) || msie4 || browserName == "Konqueror" || browserName == "Opera") {
    version = "n3";
} else {
    version = "n2";
}
function blurLink(theObject) {
    if (msie4) {
        theObject.blur();
    }
}
function decryptCharcode(n, start, end, offset) {
    n = n + offset;
    if (offset > 0 && n > end) {
        n = start + (n - end - 1);
    } else if (offset < 0 && n < start) {
        n = end - (start - n - 1);
    }
    return String.fromCharCode(n);
}
function decryptString(enc, offset) {
    var dec = "";
    var len = enc.length;
    for (var i = 0; i < len; i++) {
        var n = enc.charCodeAt(i);
        if (n >= 0x2B && n <= 0x3A) {
            dec += decryptCharcode(n, 0x2B, 0x3A, offset);
        } else if (n >= 0x40 && n <= 0x5A) {
            dec += decryptCharcode(n, 0x40, 0x5A, offset);
        } else if (n >= 0x61 && n <= 0x7A) {
            dec += decryptCharcode(n, 0x61, 0x7A, offset);
        } else {
            dec += enc.charAt(i);
        }
    }
    return dec;
}

function linkTo_UnCryptMailto(s) {
    location.href = decryptString(s, -2);
}

var $body = $("body");
var $document = $(document);
var $window = $(window);
var windowWidth = $window.width();

function initializeStickyHeader() {
    var waypoint = new Waypoint({
        element: document.getElementById('nav-waypoint'),
        handler: function (direction) {
            $('body').toggleClass('header-background', direction === 'down');
        }
    });
}


function initializeSmoothScroll() {
    $('body').smoothScroll({
        delegateSelector: '.scrolldown a',
        offset: -150,
        speed: 600
    });
}

function inititalizeSFMenu() {
    function getWindowWidth() {
        var windowWidth = 0;
        if (typeof(window.innerWidth) === 'number') {
            windowWidth = window.innerWidth;
        } else {
            if (document.documentElement && document.documentElement.clientWidth) {
                windowWidth = document.documentElement.clientWidth;
            } else {
                if (document.body && document.body.clientWidth) {
                    windowWidth = document.body.clientWidth;
                }
            }
        }
        return windowWidth;
    }

    if (getWindowWidth() > 991) {
        $('#main-nav ul .sf-mega ul').css('display', 'block');
    }

    var mainnavOptions = {
        popUpSelector: 'ul,.sf-mega',
        delay: 800,
        speed: 'normal',
        speedOut: 'normal',
        animation: {opacity:'show'},
        animationOut:  {opacity:'hide'},
        cssArrows: false
    }

    $('#main-nav > .menu > ul').superfish(mainnavOptions);

    $(window).resize(function () {
        $('body').removeClass('main-nav-active');
    });
}

function initializeFixedHeader() {
    $(window).scroll(function () {
        if ($(document).scrollTop() > 100) {
            $('body').addClass('shrinked-header');
        } else {
            $('body').removeClass('shrinked-header');
        }
    });
}


function initializeSearchBox() {
    var $mainnav = $("#main-nav");
    $(document).on('click', function (event) {
        if (!$(event.target).closest('#header-search').length) {
            $body.toggleClass('header-search-open', false);
        }
        if (!$(event.target).closest('#quick-contact').length) {
            $body.toggleClass('quick-contact-open', false);
        }
        if (!$(event.target).closest('#main-nav').length) {
            $body.toggleClass('main-nav-active', false);
        }
    });

    $(".header-search-trigger").click(function (e) {
        $body.toggleClass('header-search-open');
        if ($body.hasClass('header-search-open')) {
            $('#header-search').find('input').focus();
        }
        e.stopPropagation();
        e.preventDefault();
    });

    $(".quick-contact-trigger, .quick-contact-trigger-box").click(function (e) {
        $body.toggleClass('quick-contact-open');
        e.stopPropagation();
        e.preventDefault();
    });

    $("#trigger").click(function (e) {
        $body.toggleClass('main-nav-active');
        e.stopPropagation();
        e.preventDefault();
    });

}


function initializeSwiper() {
    var mySwiper = new Swiper('.slider-slide', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        centeredSlides: true,
        speed: $('.slider-slide').data('speed'),
        autoplay: $('.slider-slide').data('autoplay'),
        autoplayDisableOnInteraction: false,
        loop: true
    });
    var mySwiper = new Swiper('.slider-fade', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        centeredSlides: true,
        speed: $('.slider-fade').data('speed'),
        autoplay: $('.slider-fade').data('autoplay'),
        autoplayDisableOnInteraction: false,
        effect: 'fade',
        loop: true
    });

    var galleryTop = new Swiper('.gallery-top', {
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        pagination: '.swiper-pagination-thumbs',
        paginationClickable: true,
        preloadImages: false,
        lazyLoading: true,
        lazyLoadingInPrevNext: true,
        lazyLoadingInPrevNextAmount: 1
    });

    if ($(".swiper-thumbnails").length) {
        swiperThumbs(galleryTop, {
            element: 'swiper-thumbnails',
            activeClass: 'is-active'
        });
    }

    var galleryTopZoom = new Swiper('.gallery-top-zoom', {
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        pagination: '.swiper-pagination-thumbs',
        paginationClickable: true,
        preloadImages: false,
        lazyLoading: true,
        lazyLoadingInPrevNext: true,
        lazyLoadingInPrevNextAmount: 1,
        zoom: true
    });

    if ($(".swiper-thumbnails-zoom").length) {
        swiperThumbs(galleryTopZoom, {
            element: 'swiper-thumbnails-zoom',
            activeClass: 'is-active'
        });
    }
}

function initializeOpenLocations() {
    $(".location-title-toggle").click(function () {
        $(this).closest('.location-box').toggleClass("show-location");
    });
}

function initializeToogleClass() {
    $(".memorize").click(function () {
        $(".memorize").toggleClass("added-fav");
    });
}

function initializeCounter() {
    var options = {
        useEasing: true,
        easingFn: null,
        useGrouping: true,
        separator: '.',
        decimal: '.'
    };

    $(".counting-number").each(function () {
        $(this).one('inview', function (event, isInView, visiblePartX, visiblePartY) {
            if (isInView) {
                var numAnim = new CountUp(this, $(this).data("end-val"), options);
                numAnim.start()
            }
        }).html(0);
    });
}

function initMap() {

    loader
        .load()
        .then((google) => {
            new google.maps.Map(document.getElementById("googlemap"), mapOptions);
        })
        .catch(e => {
            // do something
        });
    /*
        $maps = $("#googlemap");
        if ($maps.length > 0) {
            $maps.css({height: 400});
            locations = {
                "Standort": {lat: 53.586756, lng: 10.124702}
            };

            var bounds = new google.maps.LatLngBounds();
            var infowindow = new google.maps.InfoWindow();

            var map = new google.maps.Map(document.getElementById('googlemap'), {
                scrollwheel: false,
                center: new google.maps.LatLng(53.586756, 10.124702),
                zoom: 17
            });

            for (l in locations) {
                marker = new google.maps.Marker({
                    position: locations[l],
                    map: map,
                    title: l
                });

                marker.addListener('click', function () {
                    infowindow.setContent(this.getTitle());
                    infowindow.open(map, this);
                });

                bounds.extend(marker.getPosition());
            }

            //map.fitBounds(bounds);
        }

     */
}

function setSizeOfHeaderMap($maps) {
    if ($(window).width() > 991) {
        $maps.css({height: 515});
    };

    if ($(window).width() < 991) {
        $maps.css({height: 340});
    };
    if ($(window).width() < 768) {
        $maps.css({height: 300});
    };
    if ($(window).width() < 480) {
        $maps.css({height: 200});
    };
}

function resizeHeaderMap(id, map, bounds, markerList) {
    setSizeOfHeaderMap($("#"+id));

    var i;
    for (i = 0; i < markerList.length; i++) {
        bounds.extend(markerList[i].getPosition());
    }
    map.fitBounds(bounds);
    map.setCenter(bounds.getCenter(), 13);
}

function hasUsercentricsConsent(serviceId) {
    if (typeof window.UC_UI === 'undefined' || typeof window.UC_UI.getServicesBaseInfo !== 'function') {
        return false;
    }

    return window.UC_UI.getServicesBaseInfo().some(function (service) {
        return service.id === serviceId && service.consent && service.consent.status === true;
    });
}

function initHeaderMapWithConsent($container, id, locations) {
    var serviceId = $container.data('usercentrics-service-id'),
        initialized = false,
        consentCheck,
        usercentricsCheck;

    function enableMap() {
        if (initialized || !hasUsercentricsConsent(serviceId)) {
            return false;
        }

        initialized = true;
        $container.addClass('header-map--enabled');
        window.setTimeout(function () {
            initHeaderMap(id, locations);
        }, 100);

        if (consentCheck) {
            window.clearInterval(consentCheck);
        }

        return true;
    }

    function waitForConsent() {
        if (enableMap()) {
            return;
        }

        window.clearInterval(consentCheck);
        consentCheck = window.setInterval(function () {
            if (enableMap()) {
                window.clearInterval(consentCheck);
            }
        }, 250);
    }

    function openUsercentricsSettings() {
        if (typeof window.UC_UI !== 'undefined') {
            if (typeof window.UC_UI.showSecondLayer === 'function') {
                window.UC_UI.showSecondLayer();
            } else if (typeof window.UC_UI.showFirstLayer === 'function') {
                window.UC_UI.showFirstLayer();
            }

            waitForConsent();
            return;
        }

        window.clearInterval(usercentricsCheck);
        usercentricsCheck = window.setInterval(function () {
            if (typeof window.UC_UI === 'undefined') {
                return;
            }

            window.clearInterval(usercentricsCheck);
            openUsercentricsSettings();
        }, 100);
    }

    $container.find('.header-map__consent-button').on('click', function () {
        openUsercentricsSettings();
    });

    window.addEventListener('UC_UI_INITIALIZED', enableMap);
    window.addEventListener('UC_UI_CMP_EVENT', enableMap);
    window.addEventListener('ucEvent', enableMap);
    enableMap();
}


function initHeaderMap(id, locations) {

    const loader = new Loader({
        apiKey: $("#" + id).data("api-key"),
        version: "weekly",
        libraries: ["places"]
    });

    loader
        .load()
        .then((google) => {

            setSizeOfHeaderMap($("#"+id));

            var headerMapMarker = [],
                bounds = new google.maps.LatLngBounds(),
                infowindow = new google.maps.InfoWindow(),
                mapOptions = {
                    scrollwheel: false,
                    center: new google.maps.LatLng(53.904344,9.9444553),
                    zoom: 13,
                    maxZoom: 17,
                    styles: [
                        {
                            "featureType": "all",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "saturation": 36
                                },
                                {
                                    "color": "#333333"
                                },
                                {
                                    "lightness": 40
                                }
                            ]
                        },
                        {
                            "featureType": "all",
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "all",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 17
                                },
                                {
                                    "weight": 1.2
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "visibility": "simplified"
                                },
                                {
                                    "color": "#beaf8c"
                                },
                                {
                                    "lightness": "90"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.business",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.government",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.medical",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#beaf8c"
                                },
                                {
                                    "visibility": "on"
                                },
                                {
                                    "weight": "0.8"
                                },
                                {
                                    "lightness": "0"
                                },
                                {
                                    "gamma": "1"
                                },
                                {
                                    "saturation": "0"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#beaf8c"
                                },
                                {
                                    "lightness": "23"
                                },
                                {
                                    "gamma": "1.00"
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#beaf8c"
                                },
                                {
                                    "lightness": "0"
                                },
                                {
                                    "visibility": "simplified"
                                },
                                {
                                    "gamma": "1"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "visibility": "simplified"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#1e3252"
                                },
                                {
                                    "lightness": "0"
                                },
                                {
                                    "gamma": "1"
                                }
                            ]
                        }
                    ]
                };
            var map = new google.maps.Map(document.getElementById(id), mapOptions);
            var geocoder = new google.maps.Geocoder();
            var i;
            for (i = 0; i < locations.length; i++) {
                placeMarker(map, locations[i], infowindow, geocoder, bounds, headerMapMarker);
            }

            $(window).resize(function () {
                resizeHeaderMap(id, map, bounds, headerMapMarker);
            });

            if (window.headerMapCluster!==undefined && window.headerMapCluster===true) {
                var markerCluster = new MarkerClusterer(map, headerMapMarker, {imagePath: '/typo3conf/ext/sparda/Resources/Public/Img/m', maxZoom: 10, zoomOnClick: true});
                //markerCluster.setGridSize(1);
                //markerCluster.setMaxZoom(1);
            }


        })
        .catch(e => {
            console.error('Die Google Maps Header-Karte konnte nicht initialisiert werden.', e);
        });
}



function placeMarker(map, location, infowindow, geocoder, bounds, markerList) {
    if (location.lat !== undefined && location.lng !== undefined) {
        addMarker(map, location, infowindow, { lat: location.lat, lng: location.lng }, bounds, markerList)
    } else if (location.address !== undefined) {
        geocoder.geocode({'address': location.address}, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                // console.log(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                // console.log(location.title, location.test.lat, location.test.lng);
                addMarker(map, location, infowindow, results[0].geometry.location, bounds, markerList)
            } else {
                if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                    setTimeout(placeMarker.bind(null, map, location, infowindow, geocoder, bounds, markerList), 1000);
                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                }
            }
        });
    }
}

function addMarker(map, location, infowindow, position, bounds, markerList) {
    var zIndex = 100,
        shape = null;

    if (location.icon !== undefined) {
        var image = {
            url: location.icon
        };

        if (location.size !== undefined) {
            image.size = new google.maps.Size(location.size.x, location.size.y);
        }

        if (location.origin !== undefined) {
            image.origin = new google.maps.Point(location.origin.x, location.origin.y);
        }

        if (location.anchor !== undefined) {
            image.anchor = new google.maps.Point(location.anchor.x, location.anchor.y);
        }

        if (location.shape !== undefined) {
            shape = location.shape;
        }
    }

    if (location.zIndex !== undefined) {
        zIndex = location.zIndex;
    }

    if (location.count !== undefined) {
        var marker = new google.maps.Marker({
            position: position,
            map: map,
            icon: image,
            draggable: false,
            shape: shape,
            raiseOnDrag: false,
            animation: google.maps.Animation.DROP,
            zIndex: zIndex,
            label: {
                text: String(location.count),
                color: 'black'
            }
        });
    } else {
        var marker = new google.maps.Marker({
            position: position,
            map: map,
            icon: image,
            draggable: false,
            shape: shape,
            raiseOnDrag: false,
            animation: google.maps.Animation.DROP,
            zIndex: zIndex
        });
    }

    bounds.extend(marker.getPosition());

    google.maps.event.addListener(marker, 'click', (function (map, marker, location) {
        return function () {
            if (location.offset !== undefined) {
                infowindow.setOptions({pixelOffset: new google.maps.Size(location.offset.x, location.offset.y)});
            } else {
                infowindow.setOptions({pixelOffset: new google.maps.Size(0, 0)});
            }
            infowindow.setContent('<span style="color:#000">'+location.text+'</span>');
            infowindow.open(map, marker);
        }
    })(map, marker, location));

    map.fitBounds(bounds);
    map.setCenter(bounds.getCenter(), 13);

    markerList.push(marker);
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};


Number.prototype.formatMoney = function(c, d, t){
    var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

function initializeSearch() {
    var aFilterIsSet = false;
    $(".bs-slider").each(function(){
        var $t = $(this);
        var unitValue = $t.data("unit");

        var $slider = $t.slider({});
        console.log($slider);
        console.log($t.val(),$t.val().split(","));
        var valueMinMax = $t.val().split(",");
        var isFiltered = parseFloat(valueMinMax[0]) > parseFloat($t.data("slider-min")) || parseFloat(valueMinMax[1]) < parseFloat($t.data("slider-max"));
        aFilterIsSet |= isFiltered;

        var $slider_value = $t.parent().find(".slider-value");
        var updateSliderValue = function (value) {
            var minMaxValues = value.toString().split(",");
            if (unitValue == "€") {
                for(var i in minMaxValues) {
                    minMaxValues[i] = parseFloat(minMaxValues[i]).formatMoney(0, ",", ".");
                }
            }
            $slider_value.text(minMaxValues[0] + unitValue + ' - ' +  minMaxValues[1] + unitValue);
        };
        updateSliderValue($t.val());

        $slider.on("slide", function(slideEvent) {
            debounce(updateSliderValue(slideEvent.value), 100);
        });
    });

    var $additionalFilters = $("#additional_filters");
    var $toggleAdditionalFilters = $("#toggle-additional-filters");
    $toggleAdditionalFilters.on("click", function (e) {
        e.preventDefault();
        $additionalFilters.toggle();
    });
    $additionalFilters.toggle(aFilterIsSet === 1);

    var doSubmit = debounce(function () {
        var $t = $(this);
        if($t.val() == lastSortBy) {
            $(".directions:not(:checked)").prop("checked", true);
        } else {
            $("#direction_asc").prop("checked", true);
        }

        $(this).closest("form").submit();
    }, 300);

    $(".tx-sparda-immobilien #immobilien-search select").on("change", doSubmit);
    $(".tx-sparda-immobilien #immobilien-search .slider-handle").on("mouseup", doSubmit);
    $(".tx-sparda-immobilien #immobilien-search input").on("click", doSubmit);
}

$(document).ready(function () {
    var headerMapId = "header_map",
        headerMap = $("#"+headerMapId);

    /*tn_tracking();*/

    //initMap();
    initializeSearch();
    initializeFixedHeader();
    initializeSmoothScroll();
    inititalizeSFMenu();
    initializeSearchBox();
    initializeSwiper();
    initializeCounter();
    initializeToogleClass();

    if (headerMap.length>0) {
        initHeaderMapWithConsent(headerMap.closest('.header-map'), headerMapId, headerMapLocations);
    }

    if ($(window).width() > 767) {

    }

    if ($(window).width() < 768) {
        initializeOpenLocations()
    }

    if ($(window).width() < 991) {

    }

    // Scroll to top link
    $(".top-link a").on("click", function (event) {
        event.preventDefault();
        $("html, body").animate({scrollTop: 0}, 1000);
    });

    $( ".immo-directsearch-content #immobilien-search" ).submit(function( event ) {
        var context = "Direktsuche";
        var type = $( "#immo-type option:selected" ).text();
        var object = $( "#immo-object option:selected" ).text();
        //ga('send', 'event', 'Immo '+context, 'suchen', type+' | '+object);
    });

    $( ".tx-sparda-immobilien #immobilien-search" ).submit(function( event ) {
        var context = "Detailsuche";
        var type = $( "#immo-type option:selected" ).text();
        var object = $( "#immo-object option:selected" ).text();
        var use = $( "#immo-use option:selected" ).text();
        var place = $( "#immo-place option:selected" ).text();
        //ga('send', 'event', 'Immo '+context, 'suchen', type+' | '+object+' | '+use+' | '+place);
    });

    $('.panel-accordion').on('shown.bs.collapse', function() {
        $(window).trigger("resize");
    }).on('hidden.bs.collapse', function() {
        $(window).trigger("resize");
    });

    $('.off-canvas-links li').on('click', 'a', function (event) {
        var link = this;

        event.preventDefault();
        $.smoothScroll({
            offset: -150,
            scrollTarget: link.hash,
            speed: 600
        });
        return false;
    });

    $('.off-canvas-nav-trigger').on('click', function () {
        $body.toggleClass('off-canvas-menu-active');
    });

    if ($('#pageoverlay').length > 0) {
        var hasShownOverlay = sessionStorage.getItem(olid);
        if (!hasShownOverlay) {
            sessionStorage.setItem(olid, 'ja');
            setTimeout(function () {
                $.fancybox.open(
                    [
                        {
                            src: overlayPageUID,
                            type: 'ajax',
                            filter: '#overlay-content',
                            toolbar  : false,
                            smallBtn : true,
                            iframe : {
                                preload : true,
                                css : {
                                    width : '600px'
                                }
                            }
                        }
                    ]
                );
            }, 500);

        } else {
            sessionStorage.removeItem(olid);
        }
    }
});
